import React, { FC, useContext } from 'react';

import { Input, Select } from '@smartshell/ui-kit';
import { Controller } from 'react-hook-form';

import { LocalizationContext } from 'localization';

import s from '../../../TinkoffModal.module.scss';
import { OPF_OPTION } from '../constants';
import { IFormBlockProps } from '../interfaces';
import { getIsCorrectCode, getIsCorrectDate } from '../utils';

export const UlResident: FC<IFormBlockProps> = ({ control, setError }) => {
  const { t } = useContext(LocalizationContext);

  const isCorrectDate = getIsCorrectDate(t);
  const isCorrectCode = getIsCorrectCode(t);

  return (
    <div className={s.form__block}>
      <span className={s.title}>Данные организации</span>

      <Controller
        render={({ field, fieldState: { error } }) => (
          <Select
            {...field}
            error={error?.message}
            title="Организационно-правовая форма"
            options={OPF_OPTION}
          />
        )}
        name="ul.opf"
        control={control}
        rules={{
          required: t('errors.required'),
        }}
      />

      <Controller
        render={({ field, fieldState: { error } }) => (
          <Input
            {...field}
            title="Дата регистрации организации"
            error={error?.message}
            mask="99.99.9999"
          />
        )}
        name="ul.registration_date"
        control={control}
        rules={{
          required: t('errors.required'),
          validate: isCorrectDate,
        }}
      />
      <Controller
        render={({ field, fieldState: { error } }) => (
          <Input
            {...field}
            title="Наименование"
            error={error?.message}
            onBlur={() => {
              if (!field.value && setError) {
                setError('ul.name', {
                  message: t('errors.required'),
                });
              }
            }}
          />
        )}
        name="ul.name"
        control={control}
        rules={{
          required: t('errors.required'),
        }}
      />
      <Controller
        render={({ field, fieldState: { error } }) => (
          <Input
            {...field}
            title="Адрес юридического лица"
            error={error?.message}
            onBlur={() => {
              if (!field.value && setError) {
                setError('ul.legal_entity_address', {
                  message: t('errors.required'),
                });
              }
            }}
          />
        )}
        name="ul.legal_entity_address"
        control={control}
        rules={{
          required: t('errors.required'),
          minLength: {
            value: 1,
            message: t('errors.minLength', 1),
          },
          maxLength: {
            value: 256,
            message: t('errors.maxLength', 256),
          },
        }}
      />
      <Controller
        render={({ field, fieldState: { error } }) => (
          <Input
            {...field}
            title="ОГРН"
            error={error?.message}
            mask="9999999999999"
          />
        )}
        name="ul.ogrn"
        control={control}
        rules={{
          required: t('errors.required'),
          minLength: {
            value: 13,
            message: t('errors.minLength', 13),
          },
          maxLength: {
            value: 13,
            message: t('errors.maxLength', 13),
          },
          validate: isCorrectCode,
        }}
      />
      <Controller
        render={({ field, fieldState: { error } }) => (
          <Input
            {...field}
            title="ИНН"
            error={error?.message}
            mask="9999999999"
          />
        )}
        name="ul.inn"
        control={control}
        rules={{
          required: t('errors.required'),
          minLength: {
            value: 10,
            message: t('errors.minLength', 10),
          },
          maxLength: {
            value: 10,
            message: t('errors.maxLength', 10),
          },
          validate: isCorrectCode,
        }}
      />
    </div>
  );
};
